import { StytchB2BProvider } from '@stytch/react/b2b';
import { StytchB2BUIClient } from '@stytch/vanilla-js/b2b';
import React, { ReactNode } from 'react';

interface StytchProviderProps {
  children?: ReactNode;
  stytch?: StytchB2BUIClient;
}

export const StytchProvider = ({ children, stytch }: StytchProviderProps) => {
  if (stytch) {
    return <StytchB2BProvider stytch={stytch}>{children}</StytchB2BProvider>;
  }
  return children;
};
